import type { GetServerSideProps } from 'next';
import { serialize } from 'cookie';
import Link from 'next/link';

const LoginPage = (): JSX.Element => {
  return (
    <>
      Set your xo-session-token env variable or manually go to{' '}
      <Link href="/our-wedding-checklist">
        <a>checklist</a>
      </Link>{' '}
      Or{' '}
      <Link href="/our-wedding-budget">
        <a>budgeter</a>
      </Link>
    </>
  );
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { res } = context;
  const { APP_ENV, XOTOKEN } = process.env;

  if (APP_ENV === 'development' && XOTOKEN) {
    res.setHeader(
      'Set-Cookie',
      serialize('xo-session-token', XOTOKEN, {
        maxAge: 60 * 60 * 24 * 7 * 365,
        path: '/',
        domain: '.theknot.com',
      })
    );

    res.setHeader('location', '/our-wedding-checklist');
    res.statusCode = 302;
    res.end();
    return { props: { cool: true } };
  }
  return { props: { cool: false } };
};

export default LoginPage;
